<script lang="ts">
  import SectionDocumentList from '@/generated/sections/SectionDocumentList.vue';
  import { storeSession, storeContrat, storePaie, storeDocumentType, storePaymentMeans } from '@/generated/stores';
  import Etablissement from '@/generated/classes/Etablissement';
  import Document from '@/extend/classes/Document';
  import UserProfile from '@/framework/base/classes/UserProfile';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import ListData, { ColumnFilter, DateRange, ListChoix } from '@/generated/classes/ListData';
  import { ListFilter } from '@/generated/classes/ListData';
  import Section from '@/framework/base/classes/Section';
  import SectionDocumentViewer from "@/custom/sections/SectionDocumentViewer.vue";
  import SectionContratViewer from "@/custom/sections/SectionContratViewer.vue";
  import SectionPaieViewer from "@/custom/sections/SectionPaieViewer.vue";
  import Files, { DownloadData } from '@/generated/classes/Files';
  import { getBlob } from '@/framework/files/helpers/FileTypes';
  import { defineComponent } from "vue";
  import { TransactionTypes } from "@/generated/classes/Transaction.ts";
  import PaymentMeans, { MandatStatuts } from '@/generated/classes/PaymentMeans';
  import {DateFormat} from "@/framework/base/helpers/DateFormat.ts";

  export default defineComponent({
    extends: SectionDocumentList,
    name: 'SectionDocumentListExtend',
    components: {},
    data () {
      return {
        fileName: '',
        selectedDocument: new Document(),
        isCardView: false,
        documentListRequestId: 0,
      };
    },
    computed: {
      headers (): any {
        if (this.isClient) {
          return [
            { text: "Référence", value: 'reference', cellClass: '', sortable: true },
            { text: "Catégorie", value: 'categoryId', cellClass: '', sortable: true },
            { text: "Type", value: 'typeId', cellClass: '', sortable: true },
            { text: "Projet", value: 'projetId', cellClass: '', sortable: true },
            { text: "Contrat", value: 'contratId', cellClass: '', sortable: true },
            { text: "Etablissement", value: 'etablissementId', cellClass: '', sortable: true },
            { text: "Salarié", value: 'salarieId', cellClass: '', sortable: true },
            { text: "Période", value: 'dateDebut', cellClass: '', sortable: true },
            {text: "Lu", value: 'isReadEmployeur', cellClass: '', sortable: true},
            { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
          ];
        } else if (this.isSalarie) {
          return [
            { text: "Référence", value: 'reference', cellClass: '', sortable: true },
            { text: "Catégorie", value: 'categoryId', cellClass: '', sortable: true },
            { text: "Type", value: 'typeId', cellClass: '', sortable: true },
            { text: "Contrat", value: 'contratId', cellClass: '', sortable: true },
            { text: "Etablissement", value: 'etablissementId', cellClass: '', sortable: true },
            { text: "Période", value: 'dateDebut', cellClass: '', sortable: true },
            {text: "Lu", value: 'isReadSalarie', cellClass: '', sortable: true},
            { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
          ];
        } else {
          return [
            { text: "Référence", value: 'reference', cellClass: '', sortable: true },
            { text: "Catégorie", value: 'categoryId', cellClass: '', sortable: true },
            { text: "Type", value: 'typeId', cellClass: '', sortable: true },
            { text: "Période", value: 'dateDebut', cellClass: '', sortable: true },
            {text: "Lu", value: 'isReadEmployeur', cellClass: '', sortable: true},
            { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
          ];

        }
      },
      showSelect (): boolean {
        return true;
      },
      pageLimit (): number {
        return 20;
      },
      isSalarie (): boolean {
        let res = false;
        const user = storeSession.connectedUser;
        if (user && user.id > 0) {
          res = UserProfile.isSalarie;
        }
        return res;
      },
      isClient (): boolean {
        let res = false;
        const user = storeSession.connectedUser;
        if (user && user.id > 0) {
          res = UserProfile.isClient;
        }
        return res;
      },
      section (): Section {
        const section = new Section();
        if (this.isSalarie) {
          if (this.selectedDocument.objType == ObjTypes.CONTRAT) {
            section.component = SectionContratViewer;
            section.data = storeContrat.getContrat(this.selectedDocument.objId);
            section.type = 'contrat';
            return section;
          } else if (this.selectedDocument.objType == ObjTypes.PAIE) {
            section.component = SectionPaieViewer;
            section.data = storePaie.getPaie(this.selectedDocument.objId);
            section.type = 'paie';
            return section;
          }
        }
        section.component = SectionDocumentViewer;
        section.data = this.selectedDocument;
        section.type = 'document';
        return section;
      },
      canAdd (): boolean {
        return true;
      },
      addLabel (): string {
        return 'Télécharger';
      },
      addDisabled (): boolean {
        return this.selected.length === 0 || this.loading || this.actionProgress;
      },
      items (): unknown[] {
        if (this.route && (this.route.sectionObjId != this.lastRoute.sectionObjId) || (JSON.stringify(this.route.attribut) != JSON.stringify(this.lastRoute.attribut))) {
          this.routeFilter();
          this.setLastRoute();
          this.loadTable();
        }
        return this.listData.reccords;
      },
    },

    created (): void {
      const allData = new ListFilter();
      allData.pageLimit = -1;
      storeDocumentType.registerDocumentType(allData);
      storePaymentMeans.registerPaymentMeans(allData);
      this.isCreated = true;
      Etablissement.list(new ListFilter()).then(() => {
        this.defaultFilter();
        this.loadTable();
      });
    },
    methods: {
      loadTable (): void {
        const requestId = ++this.documentListRequestId;
        this.loading = true;
        Document.list(this.filter).then((res) => {
          if (requestId !== this.documentListRequestId) return;

          const selectedIds = this.selected.map(doc => doc.id);
          this.listData = new ListData();
          this.listData = res;
          this.pageNumber = res.currentPage;

          this.selected = res.reccords.filter(doc =>
            selectedIds.includes(doc.id)
          );
        }).finally(() => {
          if (requestId === this.documentListRequestId) {
            this.loading = false;
          }
        });
        this.pageNumber = 1;
      },

      reloadTable (): void {
        if (!this.actionProgress) {
          this.loadTable();
        }
      },
      defaultFilter (): void {
        if (this.isSalarie) {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "salarieId";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          const user = storeSession.connectedUser;
          if (user && user.id > 0) {
            choix.value = user.id;
          }
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
        const filter = new ColumnFilter();
        filter.name = "dateDebut";
        filter.sortDescending = true;
        this.activeFilters.push(filter);
      },
      routeFilter(): void {
        this.activeFilters = [];
        this.pageNumber = 1;
        this.defaultFilter();

        if (
            this.route &&
            this.route.attribut &&
            this.route.attribut.columnsFilter &&
            this.route.attribut.columnsFilter.length > 0
        ) {
          this.route.attribut.columnsFilter.forEach(col => {
            let columnFilter = this.activeFilters.find(filter => filter.name === col.name);
            const newColumnFilter = !columnFilter;
            if (!columnFilter) {
              columnFilter = new ColumnFilter();
              columnFilter.name = col.name;
            }
            columnFilter.staticFilter = col.staticFilter;
            columnFilter.filters = [];

            col.filters.forEach(f => {
              const choix = new ListChoix();
              choix.value = f.value;
              choix.text = f.text;
              if (f.dateRange) {
                const dateRange = new DateRange();
                dateRange.dateDebut = new Date(f.dateRange.dateDebut);
                dateRange.dateFin = new Date(f.dateRange.dateFin);
                choix.dateRange = dateRange;
              }
              columnFilter.filters.push(choix);
            });

            if (newColumnFilter) {
              this.activeFilters.push(columnFilter);
            }
          });
        }
      },
      // extendLabel (name: string, item: number, obj: unknown): string | undefined {
      //   if (name == 'dateDebut') {
      //     return Document.getPeriod(obj as Document);
      //   }
      //   return undefined;
      // },
      selectItem (event: any, row: any): void {
        const item = row.item as Document;
        this.displayDocument(item);
      },
      displayDocument (document: Document): void {
        this.fullscreen = true;
        this.selectedDocument = document;
        this.dialogOpen = true;
      },
      hasDocument (document: Document): boolean {
        return document.fileExtension == 'pdf';
      },
      canUpdate (document: Document): boolean {
        return false;
      },
      canDelete (document: Document): boolean {
        return document.canDelete;
      },
      docExcel (document: Document): boolean {
        if (document.typeId > 0) {
          const type = storeDocumentType.getDocumentType(document.typeId);
          return !document.ci98 && type && type.excel;
        } else {
          return false;
        }
      },
      hasAction (document: Document): boolean {
        if (this.hasDocument(document)) {
          return this.docExcel(document);
        } else {
          return true;
        }
      },
      mdiAction (document: Document): string {
        let picto = 'fas fa-circle-exclamation'
        if (this.hasDocument(document)) {
          if (this.docExcel(document)) {
            picto = 'fas fa-file-excel'
          }
        } else if (document.fileExtension == 'xml') {
          picto = 'fas fa-code'
        } else if (document.fileExtension == 'eml') {
          picto = 'fas fa-envelope'
        } else if (document.fileExtension == 'htm') {
          picto = 'fas fa-html5'
        }
        return picto;
      },
      execAction (doc: Document): void {
        this.loading = true;
        this.fileName = doc.fileName;
        const data = new DownloadData();
        if (this.docExcel(doc)) {
          data.service = ObjTypes[doc.objType];
          data.type.type = 'excel';
          data.type.extension = 'xlsx';
        } else {
          data.service = 'DOWNLOAD';
          data.type.extension = doc.fileExtension;
        }
        data.data = JSON.stringify(doc);

        if (!this.actionProgress) {
          this.actionProgress = true;
            Files.download(data)
              .then((buffer) => {
                const blob = getBlob(buffer, data.type.extension);
                const file = window.URL.createObjectURL(blob);
                const docUrl = document.createElement('a');
                if (!this.fileName.endsWith(data.type.extension)) {
                  this.fileName = `${this.fileName}.${data.type.extension}`
                }
                docUrl.setAttribute('href', file);
                docUrl.setAttribute('download', this.fileName);
                document.body.appendChild(docUrl);
                docUrl.click();
                this.actionProgress = false;
              });
          }
      },
      addItem (): void {
        const ids: number[] = [];
        this.selected.forEach((item) => {
          const doc = item as Document
          ids.push(doc.id);
        });
        const data = new DownloadData();
        data.service = 'DOWNLOAD_ZIP';
        data.type.extension = 'zip';
        data.data = ids;

        if (!this.actionProgress) {
          this.actionProgress = true;
          Files.download(data)
            .then((buffer) => {
              const blob = getBlob(buffer, data.type.extension);
              const file = window.URL.createObjectURL(blob);
              const docUrl = document.createElement('a');
              const filename = `Documents CI du ${DateFormat.toFullTimestamp(new Date())}.zip`;

              docUrl.setAttribute('href', file);
              docUrl.setAttribute('download', filename);
              document.body.appendChild(docUrl);
              docUrl.click();
              setTimeout(() => { this.actionProgress = false }, 1000)
            }).catch(() => {
              this.actionProgress = false;
            });
        }

      },
    },
  });
</script>